export function useFileReader() {
  function readAsBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const fd = new FileReader();
      fd.onload = () => {
        resolve(fd.result as string);
      };

      fd.onerror = (err) => {
        reject(err);
      };

      fd.readAsDataURL(file);
    });
  }

  return {
    readAsBase64,
  };
}
